import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { useDispatch } from 'react-redux';

// components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { styled } from '@mui/styles';

import { useHistory, useLocation } from 'react-router-dom';
import {
  // SquareButton,
  squareButtonRootStyles,
} from '../../../../components/Buttons/SquareButton';
import { GROWTHBOOK_FEATURE_SETTINGS } from '../../../../store/consts/ui-settings.store.consts';
import { toggleFeatureFlags } from '../../../../store/actions/ui-settings.store.actions';

export const DashboardOptInOutModule = ({ enabled }: { enabled: boolean }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  function handleAgencyDashboardGrowthbookSwitch() {
    dispatch(
      toggleFeatureFlags(GROWTHBOOK_FEATURE_SETTINGS.NEW_AGENT_EXPERIENCE)
    );

    if (location.pathname !== '/agency/dashboard') {
      history.push('/agency/dashboard');
    }
  }

  return (
    <PositionContainer enabled={enabled}>
      <Indicator
        id="dashboard-opt-in-out"
        className="indicator"
        onClick={handleAgencyDashboardGrowthbookSwitch}
      >
        <FontAwesomeIcon
          icon={faStar}
          size="lg"
          style={{ marginRight: '8px' }}
        />
        {enabled
          ? 'Take me back to the previous version'
          : 'Try your new agent experience'}
      </Indicator>
    </PositionContainer>
  );
};

const PositionContainer = styled(Box)(({ enabled }: any) => ({
  display: 'flex',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1,

  opacity: enabled ? 0.7 : 1,

  '&:hover': {
    opacity: 1,
  },
}));

const Indicator = styled('div')({
  padding: '0.8rem 2rem',
  height: squareButtonRootStyles.height,
  position: 'relative',
  borderRadius: 5,
  backgroundImage: 'linear-gradient(to bottom right, #FF512F, #DD2476)',
  color: '#fff',
  opacity: 1,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
});
